import React, { useState, useEffect, useCallback } from 'react';
import './styles.scss';
import { NotificationManager } from "react-notifications";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useStyles } from './styles';
import { MdArrowBack, MdArrowForward, MdCheck } from 'react-icons/md';
import CircularProgress from '@material-ui/core/CircularProgress';
import { PlanConfig } from '../../../Plugin/component';
import { ReportConfig } from '../../../Plugin/component';
import { useHistory } from 'react-router-dom';
import { useParams } from "react-router-dom";
import Checkbox from '@material-ui/core/Checkbox';
import { SERVER_API_PRIVITE } from "../../../../config.json";
import { Autocomplete } from '@material-ui/lab';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { Typography } from '@material-ui/core';
const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function getSteps() {
    return ['Tên kế hoạch', 'Số bước thực hiện', 'Người quản lý template', 'Cấu hình kế hoạch'];
}

function getDefaultPlanConfig() {
    return [
        {
            colunmName: "", colunmType: "", colunmData: [""],
            colunmWidth: "", disabled: false, hidden: false, isRequired: "false",
            editFrom: "Main", KT: "", refName: "",
            input: [{ feedPlanInputConfig: "" }],
            output: [{
                colunmName: "", colunmType: "", colunmData: [],
                colunmWidth: "", disabled: false, isRequired: "false",
                value: "", editFrom: "Main", configTypeID: 0
            }],
            configTypeID: 0
        },
        {
            colunmName: "Người tạo liên quan", colunmType: "Multiple select", colunmData: [SERVER_API_PRIVITE + "api/User/GetEmail"], colunmWidth: "6", disabled: true, hidden: false, isRequired: "false", editFrom: "Main", KT: "", refName: "",
            input: [{ feedPlanInputConfig: "" }],
            output: [{
                colunmName: "", colunmType: "", colunmData: [],
                colunmWidth: "", disabled: false, isRequired: "false",
                value: "", editFrom: "Main", configTypeID: 0
            }],
            configTypeID: 0,
        },
        {
            colunmName: "Handle Step", colunmType: "Multiple select", colunmData: [SERVER_API_PRIVITE + "api/PlanTypeConfigurationMain/GetListStep?ID="], colunmWidth: "3", disabled: true, hidden: true, isRequired: "false", editFrom: "repo", KT: "", refName: "",
            input: [{ feedPlanInputConfig: "" }],
            output: [{
                colunmName: "", colunmType: "", colunmData: [],
                colunmWidth: "", disabled: false, isRequired: "false",
                value: "", editFrom: "Main", configTypeID: 0
            }],
            configTypeID: 5,
        },
        {
            colunmName: "Step", colunmType: "Multiple select", colunmData: [SERVER_API_PRIVITE + "api/PlanTypeConfigurationMain/GetListStep?ID="], colunmWidth: "3", disabled: true, hidden: true, isRequired: "false", editFrom: "repo", KT: "", refName: "",
            input: [{ feedPlanInputConfig: "" }],
            output: [{
                colunmName: "", colunmType: "", colunmData: [],
                colunmWidth: "", disabled: false, isRequired: "false",
                value: "", editFrom: "Main", configTypeID: 0
            }],
            configTypeID: 5,
        },
        {
            colunmName: "Nhân viên phụ trách", colunmType: "Multiple select", colunmData: [SERVER_API_PRIVITE + "api/User/GetEmail"], colunmWidth: "3", disabled: true, hidden: true, isRequired: "false", editFrom: "repo", KT: "", refName: "",
            input: [{ feedPlanInputConfig: "" }],
            output: [{
                colunmName: "", colunmType: "", colunmData: [],
                colunmWidth: "", disabled: false, isRequired: "false",
                value: "", editFrom: "Main", configTypeID: 0
            }],
            configTypeID: 5,
        },
        {
            colunmName: "Phân công xử lý", colunmType: "Multiple select", colunmData: [SERVER_API_PRIVITE + "api/User/GetEmail"], colunmWidth: "3", disabled: true, hidden: true, isRequired: "false", editFrom: "repo", KT: "", refName: "",
            input: [{ feedPlanInputConfig: "" }],
            output: [{
                colunmName: "", colunmType: "", colunmData: [],
                colunmWidth: "", disabled: false, isRequired: "false",
                value: "", editFrom: "Main", configTypeID: 0
            }],
            configTypeID: 5,
        },
        {
            colunmName: "Người xử lý", colunmType: "Multiple select", colunmData: [SERVER_API_PRIVITE + "api/User/GetEmail"], colunmWidth: "3", disabled: true, hidden: true, isRequired: "false", editFrom: "repo", KT: "", refName: "",
            input: [{ feedPlanInputConfig: "" }],
            output: [{
                colunmName: "", colunmType: "", colunmData: [],
                colunmWidth: "", disabled: false, isRequired: "false",
                value: "", editFrom: "Main", configTypeID: 0
            }],
            configTypeID: 5,
        },
        {
            colunmName: "Tình trạng", colunmType: "Multiple select", colunmData: ["Mới", "Từ chối", "Đóng", "Hủy"], colunmWidth: "3", disabled: true, hidden: true, isRequired: "false", editFrom: "repo", KT: "", refName: "",
            input: [{ feedPlanInputConfig: "" }],
            output: [{
                colunmName: "", colunmType: "", colunmData: [],
                colunmWidth: "", disabled: false, isRequired: "false",
                value: "", editFrom: "Main", configTypeID: 0
            }],
            configTypeID: 5,
        }
    ]
}
function getDefaultEditBy() {
    return [{
        colunmName: "", colunmType: "", colunmData: [""],
        colunmWidth: "", disabled: false, hidden: false, isRequired: "false",
        editFrom: "Main", KT: "", refName: "",
        input: [{ feedPlanInputConfig: "" }],
        output: [{
            colunmName: "", colunmType: "", colunmData: [],
            colunmWidth: "", disabled: false, isRequired: "false",
            value: "", editFrom: "Main", configTypeID: 0
        }],
        configTypeID: 0
    }]
}
function getDefaultOuput() {
    return {
        colunmName: "", colunmType: "", colunmData: [],
        colunmWidth: "", disabled: false, isRequired: "false",
        value: "", editFrom: "Main", configTypeID: 0
    }
}

function getDefaultInput() {
    return {
        feedPlanInputConfig: ""
    }
}

const getDefaultFilterConfig = () => {
    return [{
        colunmName: "",
        colunmType: "",
        colunmData: [],
        colunmWidth: "",
        colunmNewName: "",
        disabled: false,
        configTypeID: 3
    }
    ];
}

const getDefaultReportData = () => {
    return [{
        colunmName: "",
        pinColunm: "",
        configTypeID: 0
    }];
}

function BodyStepPlanName(props) {
    return <TextField
        className="col-md-4"
        fullWidth
        id="outlined-name"
        label="Tên kế hoạch"
        margin="dense"
        variant="outlined"
        InputLabelProps={{
            shrink: true,
        }}
        onChange={(e) => props.onChange(e)}
        value={props.value}
    />;
}
function BodyStepManagerPlanType(props) {
    return <Autocomplete
        multiple
        limitTags={4}
        id="combo-box"
        options={props.Data}
        disableCloseOnSelect
        renderOption={(option, { selected }) => {
            return (
                <React.Fragment>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    <Typography noWrap style={{ fontSize: "13px" }}>{option.email}</Typography>
                </React.Fragment>
            )
        }}
        getOptionLabel={(option) => option.email}
        style={{ width: "50%" }}
        size='small'
        renderInput={(params) => <TextField {...params} InputLabelProps={{
            shrink: true,
        }} margin="dense" label="Người quản lý" variant="outlined" />}
        className="PlanTemplate_0013"
        onChange={(e, newValue) => props.onChange(newValue)}
        value={props.value ? props.value : []}
    />
}

function BodyStepNumberPerform(props) {
    return <TextField
        className="col-md-4"
        fullWidth
        id="outlined-name"
        label="Số bước thực hiện"
        margin="dense"
        variant="outlined"
        InputLabelProps={{
            shrink: true,
        }}
        onChange={(e) => props.onChange(e)}
        value={props.value}
        disabled={props.disabled}
    />;
}
const FeedsDefault = []

function getFeedsData(planConfig) {
    const FeedsData = [...FeedsDefault];
    for (let i = 0; i < planConfig.length; i++) {
        // eslint-disable-next-line 
        if (planConfig[i].colunmType != "Link liên kết")
            FeedsData.push(`[[${planConfig[i].colunmName}]]`);
        if (planConfig[i].output) {
            if (planConfig[i].output.length > 0) {
                var ouput = planConfig[i].output
                for (let index = 0; index < ouput.length; index++) {
                    const element = ouput[index];
                    FeedsData.push(`[[${element.colunmName}]]`);
                }
            }
        }
    }

    const FeedsDataDisplay = [];
    for (let i = 0; i < FeedsData.length; i++) {

        FeedsDataDisplay.push({
            id: i, display: FeedsData[i]
        });
    }

    return { feedsDataDisplay: FeedsDataDisplay, feedsData: FeedsData };
}

function getStepContent(stepIndex, Handle, handleOnclickCheckBox) {
    switch (stepIndex) {
        case 0:
            return <BodyStepPlanName onChange={Handle.HandleStepPlanName.fn} value={Handle.HandleStepPlanName.value} />;
        case 1:
            return <BodyStepNumberPerform onChange={Handle.HandleStepNumberPerform.fn} value={Handle.HandleStepNumberPerform.value} disabled={Handle.HandleStepNumberPerform.disabled} />;
        case 2:
            return <BodyStepManagerPlanType Data={Handle.HandleStepManager.value} value={Handle.HandleStepManager.valueItems} onChange={Handle.HandleStepManager.fn} />
        case 3:
            return <>
                <div style={{ marginRight: "auto", fontSize: "x-large", marginTop: "-75px", marginBottom: "10px" }}> Thao tác</div>
                <div className="checkBox" style={{ marginRight: "auto" }}>
                    <Checkbox onClick={handleOnclickCheckBox}
                        defaultChecked
                    />
                    <lable style={{ fontSize: 'medium', left: "-5px" }}>Lưu lịch sử thao tác </lable>
                    <Checkbox onClick={Handle.HandleCheckDate.fn.handleOnclickCheckDate}
                        checked={Handle.HandleCheckDate.isCheckDate}
                    />
                    <lable style={{ fontSize: 'medium', left: "-5px" }}>Kiểm tra điều kiện thời gian</lable>
                </div>
                <PlanConfig
                    onClickDeleteGeneral={Handle.HandlePlanConfig.fn.btnDeleteConfig}
                    onClickUp={Handle.HandlePlanConfig.fn.btnUpConfig}
                    onClickDown={Handle.HandlePlanConfig.fn.btnDownConfig}
                    onClickGeneral={Handle.HandlePlanConfig.fn.btnAddConfigDataClick}
                    onChangeGeneral={Handle.HandlePlanConfig.fn.InputOnchange}
                    valueGeneral={Handle.HandlePlanConfig.value}
                    onDragDrop={Handle.HandlePlanConfig.fn.handleDragDrop}
                    onChecked={Handle.HandlePlanConfig.fn.handleChecked}
                    FeedsConfigField={Handle.HandlePlanConfigData.FeedsConfigField}
                    btnAddConfigDataOuput={Handle.HandlePlanConfig.fn.btnAddConfigDataOuput}
                    btnDeleteOuputConfig={Handle.HandlePlanConfig.fn.btnDeleteOuputConfig}
                    HandleAddConfigInputData={Handle.HandlePlanConfig.fn.HandleAddConfigInputData}
                    btnDeleteInput={Handle.HandlePlanConfig.fn.btnDeleteInput}
                    btnDownInput={Handle.HandlePlanConfig.fn.btnDownInput}
                    btnUpInput={Handle.HandlePlanConfig.fn.btnUpInput}
                    btnDownOutput={Handle.HandlePlanConfig.fn.btnDownOutput}
                    btnUpOutput={Handle.HandlePlanConfig.fn.btnUpOutput}
                    onClickCopy={Handle.HandlePlanConfig.fn.btnCopyConfigClick}
                />
                <ReportConfig
                    valueFilterGeneral={Handle.HandlePlanConfigFilter.valueName}
                    valueFilter={Handle.HandlePlanConfigFilter.value}
                    onClickFilter={Handle.HandlePlanConfigFilter.fn.btnAddFilterConfigClick}
                    onChangeFilter={Handle.HandlePlanConfigFilter.fn.InputOnchange}
                    onClickDeleteFilter={Handle.HandlePlanConfigFilter.fn.btnDeleteConfig}
                    valueReportData={Handle.HandlePlanConfigData.value}
                    onChangeConfigType={Handle.HandlePlanConfigData.fn.InputOnchangeConfigType}
                    onChangePinColunm={Handle.HandlePlanConfigData.fn.InputOnchangePinColunm}
                    onChangePageConfig={Handle.HandlePlanConfig.fn.OnChangePageConfig}
                    pageReport={Handle.HandlePlanConfig.page}
                    onClickReport={Handle.HandlePlanConfigData.fn.btnAddDataConfigClick}
                    onClickDeleteData={Handle.HandlePlanConfigData.fn.btnDeleteConfig}
                    onDragDrop={Handle.HandlePlanConfig.fn.handleDragDrop}
                />
            </>;
        default:
            return 'Unknown stepIndex';
    }
}

export default function NewComponent(props) {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [planName, setPlanName] = useState("");
    const [stepNumberPerform, setStepNumberPerform] = useState("");
    const [stepDataManager, setStepDataManager] = useState([]);
    const [planConfig, setPlanConfig] = useState(getDefaultPlanConfig());
    const steps = getSteps();
    const history = useHistory();
    const { id } = useParams();
    const [filterConfig, setFilterConfig] = useState(getDefaultFilterConfig());
    const [reportData, setReportData] = useState(getDefaultReportData());
    const [pageReport, setPageReport] = useState(1)
    const [feedsConfigField, setFeedsConfigField] = useState("");
    const [cbActionHisroty, setCbActionHisroty] = useState(true);
    const [getHistory, setGetHistory] = useState();
    const [planConfigFilter, setPlanConfigFilter] = useState(planConfig);
    const [isCheckDate, setIsCheckDate] = useState(true); // mặc định khi thiết lập template là kiểm tra điều kiện ngày

    /*=============================================================================================
    Summary:     Xử lý khi click checkBox
    Author:      Sangvtt2
    Date:        14-04-2022 
    =============================================================================================*/
    const handleOnclickCheckBox = () => {
        setCbActionHisroty(!cbActionHisroty);
    }
    useEffect(() => {
        const creator = props.DataEmail && props.DataEmail.filter((item) => item.userCode.trim() === localStorage.getItem('User').trim());
        setStepDataManager(creator);
    }, [props.DataEmail])
    useEffect(() => {
        props.GetDataEmail();
        if (id) {
            props.GetDataNew(id);
        }
        else {
            setPlanName("");
            setStepNumberPerform("");
            setPlanConfig(getDefaultPlanConfig());
            setFilterConfig(getDefaultFilterConfig());
            setReportData(getDefaultReportData());
        }
        // eslint-disable-next-line 
    }, [])


    // useEffect(() => {
    //     if (id && props.DataNew) {
    //         props.DataNew.map((item, index) => {
    //             console.log('this is datanew', item, index)
    //         })
    //         setPlanName(props.DataNew[0].planName);
    //         setStepNumberPerform(props.DataNew[0].stepNumber);
    //         setPlanConfig(() => {
    //             return props.DataNew.map((item) => {
    //                 return { colunmName: item.name, colunmType: item.type, colunmData: item.data.split("*"), colunmWidth: item.flex.toString(), disabled: false, isRequired: false, editFrom: item.editFrom }
    //             })
    //         })
    //     }
    // }, [props.DataNew])

    useEffect(() => {
        if (id && history && history.location.pathname === `/PlanTemplate/Edit/${id}` && history.action === "PUSH" && history.location.state) {
            const { state } = history.location
            setActiveStep(3)
            setPlanConfig(state.planConfig)
            setPlanName(state.planName);
            setStepNumberPerform(state.stepNumberPerform);
            setPageReport(state.pageReport)
            setFilterConfig(state.filterConfig)
            setReportData(state.planConfig.filter(item => { return item.configTypeID === 4 }))
            setGetHistory(history)
            setIsCheckDate(state.IsValidateDate);
            let users = state.dataManager && state.dataManager.split(',');
            // eslint-disable-next-line 
            props.DataEmail && props.DataEmail.map((item) => {
                if (item.userCode.trim() === localStorage.getItem('User').trim()) {
                    setStepDataManager(prev => [...prev, item]);
                }
                else {
                    // eslint-disable-next-line 
                    users && users.map((item1) => {
                        if (item.userCode === item1.trim()) {
                            const check = stepDataManager && stepDataManager.filter((item2) => item2.userCode === item1.userCode);
                            if (check.length === 0) {
                                setStepDataManager(prev => [...prev, item]);
                            }
                        }
                    })
                }
            })
        }
        else if (id && props.DataNew) {
            setStepDataManager([]);
            setPlanName(props.DataNew[0].planName);
            setIsCheckDate(props.DataNew && props.DataNew[0].isValidateDate)
            setStepNumberPerform(props.DataNew[0].stepNumber);
            setPageReport(props.DataNew[0].page)
            let users = props.DataNew[0].users && props.DataNew[0].users.split(',');
            // eslint-disable-next-line 
            props.DataEmail && props.DataEmail.map((item) => {
                if (item.userCode.trim() === localStorage.getItem('User').trim()) {
                    setStepDataManager(prev => [...prev, item]);
                }
                else {
                    // eslint-disable-next-line 
                    users && users.map((item1) => {
                        if (item.userCode === item1.trim()) {
                            const check = stepDataManager && stepDataManager.filter((item2) => item2.userCode === item1.userCode);
                            if (check.length === 0) {
                                setStepDataManager(prev => [...prev, item]);
                            }
                        }
                    })
                }
            })
            const dataPlanConfig = props.DataNew.filter((item) => { return item.configTypeID !== 3 })
            dataPlanConfig.length > 0 && setPlanConfig(() => {
                var FeedArrPlanConfig = [];
                //set config linkReference

                //item.colunmType === 'ReferenedField' ? item.colunmData : item.colunmData.join("*")
                //item.data.split("*")
                // eslint-disable-next-line 
                dataPlanConfig.map((item) => {
                    FeedArrPlanConfig.push({
                        colunmName: item.name,
                        colunmType: item.type, colunmData: item.data ? item.type === 'Link liên kết' ? item.data : item.data.split("*") : "", colunmWidth: item.flex.toString(),
                        disabled: false, isRequired: item.isRequired, editFrom: item.editFrom, configTypeID: item.configTypeID, pinColunm: item.pinColumn
                    })
                })
                setFeedsConfigField(getFeedsData(FeedArrPlanConfig));

                const arrGeneral = FeedArrPlanConfig.filter((item) => item.colunmName !== 'Handle Step' && item.colunmName !== 'Step' && item.colunmName !== 'Nhân viên phụ trách' && item.colunmName !== 'Phân công xử lý' && item.colunmName !== 'Người xử lý' && item.colunmName !== 'Tình trạng');
                const arrDatareport = FeedArrPlanConfig.filter((item) => item.colunmName === 'Handle Step' || item.colunmName === 'Step' || item.colunmName === 'Nhân viên phụ trách' || item.colunmName === 'Phân công xử lý' || item.colunmName === 'Người xử lý' || item.colunmName === 'Tình trạng');
                const planConfigSort = arrGeneral.concat(arrDatareport);
                setPlanConfigFilter(planConfigSort);

                const cloneData = dataPlanConfig.map((item) => {
                    return {
                        colunmName: item.name, colunmType: item.type, colunmData: item.data ? item.type === 'Link liên kết' ? item.data : item.data.split("*") : "",
                        colunmWidth: item.flex.toString(), disabled: item.name === 'Người tạo liên quan' ? true : false, hidden: item.name === 'Handle Step' || item.name === 'Step'
                            || item.name === 'Nhân viên phụ trách' || item.name === 'Phân công xử lý' || item.name === 'Người xử lý' || item.name === 'Tình trạng' ? true : false
                        , isRequired: item.isRequired,
                        editFrom: item.editFrom, configTypeID: item.configTypeID, pinColunm: item.pinColumn, KT: item.kt, refName: item.refName,
                        input: item.input ? item.input : [getDefaultInput()],
                        output: item.output ? item.output.map((items) => {
                            return {
                                colunmName: items.name, colunmType: items.type, colunmData: items.data,
                                colunmWidth: items.flex.toString(), disabled: false, isRequired: items.isRequired,
                                editFrom: items.editFrom, configTypeID: items.configTypeID, pinColunm: null, KT: items.KT, value: items.value
                            }
                        }) : [getDefaultOuput()]
                    }
                });

                // console.log("cloneData", cloneData.push(
                //     {
                //         "colunmName": "PM(email)",
                //         "colunmType": "Azure Email",
                //         "colunmData": "",
                //         "colunmWidth": "3",
                //         "disabled": false,
                //         "hidden": false,
                //         "isRequired": "false",
                //         "editFrom": "Main",
                //         "configTypeID": 4,
                //         "pinColunm": false,
                //         "KT": "",
                //         "refName": "",
                //         "input": [
                //             {
                //                 "feedPlanInputConfig": ""
                //             }
                //         ],
                //         "output": [
                //             {
                //                 "colunmName": "",
                //                 "colunmType": "",
                //                 "colunmData": [],
                //                 "colunmWidth": "",
                //                 "disabled": false,
                //                 "isRequired": "false",
                //                 "value": "",
                //                 "editFrom": "Main",
                //                 "configTypeID": 0
                //             }
                //         ]
                //     }
                // ), cloneData)
                return cloneData
            })
            const dataFilterConfig = props.DataNew.filter((item) => { return item.configTypeID === 3 })
            dataFilterConfig.length > 0 && setFilterConfig(() => {
                return dataFilterConfig.map((item) => {
                    return { colunmName: item.name, colunmType: item.type, colunmData: item.data.split("*"), colunmWidth: item.flex.toString(), colunmNewName: item.rename, configTypeID: item.configTypeID }
                })
            })
            const valueReportData = props.DataNew.filter((plan) => { return plan.configTypeID === 4 })
            valueReportData.length > 0 && setReportData(() => {
                return valueReportData.map((item) => {
                    return { colunmName: item.name, colunmType: item.type, colunmData: item.data.split("*"), colunmWidth: item.flex.toString(), disabled: false, isRequired: item.isRequired, editFrom: item.editFrom, configTypeID: item.configTypeID, pinColunm: item?.pinColumn }
                })
            })
        }
        //  return () => {
        //      history({})
        //  }
        // eslint-disable-next-line 
    }, [props.DataNew, id])


    const handleNext = () => {
        if ((activeStep === 0 && planName !== "") || (activeStep === 1 && stepNumberPerform !== "") || (activeStep === 2 && (stepDataManager && stepDataManager.length > 0))) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
        else {
            NotificationManager.error("Vui lòng nhập thông tin.");
        }
    };
    const handleComplete = () => {
        let DataPlanConfig = planConfig.filter((item) => { return item.colunmName !== "" })
        // eslint-disable-next-line 
        let DataPlanConfigFail = DataPlanConfig.filter((item) => {
            if (item.colunmType === "") {
                return item;
            } else if (item.colunmType !== "Link liên kết" && (item.colunmWidth === null || item.colunmWidth === "")) {
                return item;
            }
            // return item.colunmType === "" || (item.colunmType !== "Link liên kết" && item.colunmWidth === "")
        })
        // let DataPlanConfigWidthFail = DataPlanConfig.filter((item) => { return item.colunmType === "" || item.colunmWidth === ""})
        let DataPlanConfigComboboxFail = DataPlanConfig.filter((item) => { return (item.colunmType === "Combobox" || item.colunmType === "Multiple select") && item.colunmData.length < 1 })
        // Data filter validate
        let DataFilterConfig = filterConfig.filter((item) => { return item.colunmName !== "" })
        let DataFilterConfigFail = DataFilterConfig.filter((item) => { return item.colunmType === "" || item.colunmWidth === "" })
        let DataFilterConfigComboboxFail = DataFilterConfig.filter((item) => { return (item.colunmType === "Combobox" || item.colunmType === "Multiple select") && item.colunmData.length < 1 })
        // check filter config and result config
        let DataReportConfigIsNull = reportData.length === 1 && (reportData[0].colunmName === "")
        let DataReportConfig = reportData.filter((item) => { return item.colunmName !== "" })
        let DataFilterConfigIsNull = filterConfig.length === 1 && (filterConfig[0].colunmName === "")
        var checkInput = true;
        // eslint-disable-next-line 
        DataPlanConfig.filter(item1 => {
            if (item1.colunmType === "Link liên kết" && item1.input) {
                item1.input.forEach(element => {
                    if (element.feedPlanInputConfig === "") {
                        checkInput = false;
                        return;
                    }
                });
            }
        });
        var checkOuput = true;
        // eslint-disable-next-line 
        DataPlanConfig.filter(item1 => {
            if (item1.colunmType === "Link liên kết") {
                var countOuput = item1.output.filter((item) => { return item.colunmName !== "" });
                if (item1.KT === "") {
                    checkOuput = false;
                    // eslint-disable-next-line 
                    return;
                }
                if (countOuput.length < 1) {
                    checkOuput = false;
                    // eslint-disable-next-line 
                    return;
                }
                if (item1.output) {
                    item1.output.forEach(element => {
                        if (element.colunmWidth === "" || ((element.colunmType === "Combobox" || element.colunmType === "Multiple select") && (element.colunmData === "" || element.colunmData.length === 0))) {
                            checkOuput = false;
                            return;
                        }
                    });
                }
            }

        });
        let datatmp = '';
        // eslint-disable-next-line 
        stepDataManager && stepDataManager.map((item) => {
            datatmp = datatmp + item.userCode + ',';
        })

        let DataConfigExpert = planConfig.filter((item) => item.colunmName === '');
        let DataPlanConfigRefFail = planConfig.filter((item) => { return (item.colunmType === "Link liên kết" && (item.colunmName === "" || item.colunmData === "" || (item.KT === null || item.KT === ""))) });
        if (DataPlanConfig.length < 1 || DataConfigExpert.length > 0 || DataPlanConfigFail.length > 0 || DataPlanConfigRefFail.length > 0 || DataPlanConfigComboboxFail.length > 0 || checkInput === false || checkOuput === false) {
            NotificationManager.error("Vui lòng nhập thông tin cấu hình chung.");
        } else if (DataFilterConfigFail.length > 0 || DataFilterConfigComboboxFail.length > 0) {
            NotificationManager.error("Vui lòng nhập thông tin cấu hình bộ lọc báo cáo.");
        } else if (DataFilterConfig.length > 0 && DataReportConfigIsNull) {
            NotificationManager.error("Vui lòng nhập thông tin cấu hình kết quả báo cáo.");
        } else if (DataReportConfig.length > 0 && DataFilterConfigIsNull) {
            NotificationManager.error("Vui lòng nhập thông tin cấu hình bộ lọc báo cáo.");
        }
        else {
            if (id) {
                history.push({ pathname: `/PlanTemplate/Edit/${id}/PlanConfigByStep`, state: { id: id, planName: planName, stepNumberPerform: stepNumberPerform, dataManager: datatmp.substring(datatmp.length - 1, 0), planConfig: planConfig, filterConfig, pageReport, cbACtionHistory: cbActionHisroty, bodySteps: getHistory?.location?.bodySteps, feeds: getHistory?.location?.feeds, steps: getHistory?.location?.steps, IsValidateDate: isCheckDate } })
            }
            else {
                history.push({ pathname: "/PlanTemplate/new/PlanConfigByStep", state: { planName: planName, stepNumberPerform: stepNumberPerform, dataManager: datatmp.substring(datatmp.length - 1, 0), planConfig: planConfig, filterConfig, pageReport, cbACtionHistory: cbActionHisroty, bodySteps: getHistory?.location?.bodySteps, feeds: getHistory?.location?.feeds, steps: getHistory?.location?.steps, IsValidateDate: isCheckDate } })
            }
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const HandleStepPlanName = (e) => {
        setPlanName(e.target.value)
    }

    const HandleStepNumberPerform = (e) => {
        if (!isNaN(+e.target.value)) {
            setStepNumberPerform(e.target.value)
        }
    }

    const HandleAddConfigData = () => {
        const checkNull = planConfig.filter((item) => item.colunmName === '');
        if (checkNull.length >= 1) {
            NotificationManager.error("Vui lòng hoàn thành dữ liệu trước khi thêm.");
        }
        else {
            setPlanConfig([...planConfig.filter((item) => item.colunmName !== 'Người tạo liên quan'), ...getDefaultEditBy(), ...planConfig.filter((item) => item.colunmName === 'Người tạo liên quan')]);
        }
        // let LastItem = planConfig.filter((item, index) => {
        //     return index === planConfig.length - 8;
        // });

        // let LastPriItem = planConfig.filter((item, index) => {
        //     return index === planConfig.length - 7;
        // });

        // if (LastItem[0].colunmName !== "") {
        //     //setPlanConfig([...planConfig.slice(0,planConfig.length-1), ...getDefaultEditBy(),...getDefaultPlanConfig().slice(1,planConfig.length)])
        //     if (LastPriItem[0].colunmName === 'Người tạo liên quan') {
        //         setPlanConfig([...planConfig.filter((item) => item.colunmName !== 'Người tạo liên quan'), ...getDefaultEditBy(), ...planConfig.filter((item) => item.colunmName === 'Người tạo liên quan')]);
        //     }
        //     else {
        //         setPlanConfig([...planConfig, ...getDefaultEditBy()]);
        //     }
        // }
        // else {
        //     NotificationManager.warning("Vui lòng hoàn thành dữ liệu trước khi thêm.");
        // }
    }

    const HandleInputOnchangeGeneral = (e, index, key, chillIndex) => {
        if (key === "colunmName") {
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    colunmName: e.target.value,
                },
                ...planConfig.slice(index + 1)
            ]);
        }
        else if (key === "colunmType") {
            if (e === "Link liên kết") {
                planConfig[index].output[0].colunmName = planConfig[index].colunmName;
                setPlanConfig([
                    ...planConfig.slice(0, index),
                    {
                        ...planConfig[index],
                        output: planConfig[index].output,
                    },
                    ...planConfig.slice(index + 1)
                ]);
            }
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    colunmType: e,
                },
                ...planConfig.slice(index + 1)
            ]);
        }
        else if (key === "colunmData") {
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    colunmData: e,
                },
                ...planConfig.slice(index + 1)
            ]);
        }
        else if (key === "colunmWidth") {
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    colunmWidth: e,
                },
                ...planConfig.slice(index + 1)
            ]);
        }
        //set API 
        else if (key === "urlAPI") {
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    urlAPI: e.target.value,
                },
                ...planConfig.slice(index + 1)
            ]);
        }
        //initFlag
        else if (key === "initFlag") {
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    KT: e,
                },
                ...planConfig.slice(index + 1)
            ]);
        }
        //referenceField
        else if (key === "referenceField") {

            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    refName: e,
                },
                ...planConfig.slice(index + 1)
            ]);
        }
        else if (key === "referenceField1") {

            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    testfield: e,
                },
                ...planConfig.slice(index + 1)
            ]);
        }
        else if (key === "FeedPlanInputConfig") {
            // var stringsss=  e.join("*")
            planConfig[index].input.forEach((element, index) => {
                if (index === chillIndex) {
                    element.feedPlanInputConfig = e;
                }
            });
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    input: planConfig[index].input,
                },
                ...planConfig.slice(index + 1)
            ]);
        } else if (key === "outputColunmName") {
            planConfig[index].output.forEach((element, index) => {
                if (index === chillIndex) {
                    element.colunmName = e.target.value;
                }
            });
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    output: planConfig[index].output,
                },
                ...planConfig.slice(index + 1)
            ]);
        } else if (key === "outputcolunmType") {
            planConfig[index].output.forEach((element, index) => {
                if (index === chillIndex) {
                    element.colunmType = e
                }
            });
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    output: planConfig[index].output,
                },
                ...planConfig.slice(index + 1)
            ]);
        } else if (key === "outputcolunmWidth") {
            planConfig[index].output.forEach((element, index) => {
                if (index === chillIndex) {
                    element.colunmWidth = e
                }
            });
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    output: planConfig[index].output,
                },
                ...planConfig.slice(index + 1)
            ]);
        } else if (key === "outputcolunmData") {
            planConfig[index].output.forEach((element, index) => {
                if (index === chillIndex) {
                    element.value = e.target.value
                }
            });
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    output: planConfig[index].output,
                },
                ...planConfig.slice(index + 1)
            ]);
        } else if (key === "outputmapping") {
            planConfig[index].output.forEach((element, index) => {
                if (index === chillIndex) {
                    element.colunmData = e.target.value
                }
            });
            setPlanConfig([
                ...planConfig.slice(0, index),
                {
                    ...planConfig[index],
                    output: planConfig[index].output,
                },
                ...planConfig.slice(index + 1)
            ]);
        }
        setFeedsConfigField(getFeedsData(planConfig));
        const arrGeneral = planConfig.filter((item) => item.colunmName !== 'Handle Step' && item.colunmName !== 'Step' && item.colunmName !== 'Nhân viên phụ trách' && item.colunmName !== 'Phân công xử lý' && item.colunmName !== 'Người xử lý' && item.colunmName !== 'Tình trạng');
        const arrDatareport = planConfig.filter((item) => item.colunmName === 'Handle Step' || item.colunmName === 'Step' || item.colunmName === 'Nhân viên phụ trách' || item.colunmName === 'Phân công xử lý' || item.colunmName === 'Người xử lý' || item.colunmName === 'Tình trạng');
        const planConfigSort = arrGeneral.concat(arrDatareport);
        setPlanConfigFilter(planConfigSort);
    }

    const HandleChecked = (checked, index) => {
        setPlanConfig([
            ...planConfig.slice(0, index),
            {
                ...planConfig[index],
                isRequired: checked.toString(),
            },
            ...planConfig.slice(index + 1)
        ])
    }

    const HandlePlanConfigDelete = (valueDelete) => {
        const { index, name } = valueDelete
        const Array = planConfig.filter(item => { return item.colunmName === name })
        const ArrayFilter = filterConfig.filter(item => { return item.colunmName === name })
        const ArrayReport = reportData.filter(item => { return item.colunmName === name })
        if (planConfig.length > 1) {
            setPlanConfig([
                ...planConfig.slice(0, index),
                ...planConfig.slice(index + 1)
            ])
            if (name !== "" && Array.length === 1) {
                if (filterConfig.length === 1) {
                    setFilterConfig(getDefaultFilterConfig())
                } else {
                    const newFilterConfig = filterConfig.filter((value) => {
                        return value.colunmName !== name
                    })
                    setFilterConfig(newFilterConfig)
                    const newReportData = reportData.filter((value) => {
                        return value.colunmName !== name
                    })
                    setReportData(newReportData)
                }
                if (reportData.length === 1) {
                    setReportData(getDefaultReportData())
                }
            }
            else if (name !== "" && ArrayFilter.length > 1) {
                const ValueFilterDelete = filterConfig.find((value) => {
                    return value.colunmName === name
                })
                const newFilterConfig = filterConfig.filter((value) => {
                    return value !== ValueFilterDelete
                })
                setFilterConfig(newFilterConfig)
            } else if (name !== "" && ArrayReport.length > 1) {
                const ValueReportDelete = reportData.find((value) => {
                    return value.colunmName === name
                })
                const newReportData = reportData.filter((value) => {
                    return value !== ValueReportDelete
                })
                setReportData(newReportData)
            }
        }
        else {
            NotificationManager.error("Không thể xóa.");
        }
    }

    const HandlePlanConfigUp = (index) => {
        if (planConfig.length > 1 && index > 0) {
            let planConfigCopy = [...planConfig];
            let itemWithIndex = planConfigCopy[index];

            planConfigCopy[index] = planConfigCopy[index - 1];
            planConfigCopy[index - 1] = itemWithIndex;

            setPlanConfig(planConfigCopy)
        }
        else {
            NotificationManager.error("Không thể chuyển vị trí.");
        }
    }

    const HandlePlanConfigDown = (index) => {
        if (planConfig.length > 1 && index < planConfig.length - 1) {
            let planConfigCopy = [...planConfig];
            let itemWithIndex = planConfigCopy[index];

            planConfigCopy[index] = planConfigCopy[index + 1];
            planConfigCopy[index + 1] = itemWithIndex;

            setPlanConfig(planConfigCopy)
        }
        else {
            NotificationManager.error("Không thể chuyển vị trí.");
        }
    }



    const HandleDragDrop = useCallback((arrayDragDrop) => {
        const { values, type } = arrayDragDrop
        if (type === "General") {
            //console.log("values", values);
            const planConfigCopy = values.map((value) => value.content.props.value);
            setPlanConfig(planConfigCopy);
        } else if (type === "Filter") {
            const filterConfigCopy = values.map((value) => value.content.props.valueFilter);
            setFilterConfig(filterConfigCopy);
        } else if (type === "ReportData") {
            const reportDataCopy = values.map((value) => value.content.props.valueReportData);
            setReportData(reportDataCopy);
        }
    }, []);

    const HandleInputOnchangeFilter = (newValue, index, type) => {
        // const arrGeneral = planConfig.filter((item) => item.colunmName !== 'Handle Step' && item.colunmName !== 'Step' && item.colunmName !== 'Nhân viên phụ trách' && item.colunmName !== 'Phân công xử lý'  );
        // const arrDatareport = planConfig.filter((item) => item.colunmName === 'Handle Step' || item.colunmName === 'Step' || item.colunmName === 'Nhân viên phụ trách' || item.colunmName === 'Phân công xử lý');
        // const planConfigSort = arrGeneral.concat(arrDatareport);
        // setPlanConfig(planConfigSort);
        const itemPlanConfig = planConfig.find(valueGeneral => {
            return valueGeneral.colunmName === newValue
        })

        if (!newValue && type === "colunmName") {
            setFilterConfig([
                ...filterConfig.slice(0, index),
                ...getDefaultFilterConfig(),
                ...filterConfig.slice(index + 1)
            ])
        }
        else {
            if (type === "colunmName") {
                setFilterConfig([
                    ...filterConfig.slice(0, index),
                    {
                        ...filterConfig[index],
                        colunmName: newValue ? newValue : "",
                        colunmType: itemPlanConfig.colunmType !== "Link liên kết" ? itemPlanConfig.colunmType : "Input text",
                        colunmData: itemPlanConfig.colunmData
                    },
                    ...filterConfig.slice(index + 1)
                ])
            } else if (type === "colunmType") {
                setFilterConfig([
                    ...filterConfig.slice(0, index),
                    {
                        ...filterConfig[index],
                        colunmType: newValue,
                    },
                    ...filterConfig.slice(index + 1)
                ])
            } else if (type === "colunmData") {
                setFilterConfig([
                    ...filterConfig.slice(0, index),
                    {
                        ...filterConfig[index],
                        colunmData: newValue,
                    },
                    ...filterConfig.slice(index + 1)
                ])
            } else if (type === "colunmWidth") {
                setFilterConfig([
                    ...filterConfig.slice(0, index),
                    {
                        ...filterConfig[index],
                        colunmWidth: newValue,
                    },
                    ...filterConfig.slice(index + 1)
                ])
            } else if (type === "colunmNewName") {
                setFilterConfig([
                    ...filterConfig.slice(0, index),
                    {
                        ...filterConfig[index],
                        colunmNewName: newValue,
                    },
                    ...filterConfig.slice(index + 1)
                ])
            }
        }
        //console.log("filerConfig", filterConfig);
    }

    const HandleAddFilterConfig = () => {
        let LastItem = filterConfig.filter((item, index) => {
            return index === filterConfig.length - 1;
        });
        if (LastItem[0].colunmName !== "") {
            setFilterConfig([...filterConfig, ...getDefaultFilterConfig()])
        }
        else {
            NotificationManager.error("Vui lòng hoàn thành dữ liệu trước khi thêm.");
        }
    }

    const HandleFilterConfigDelete = (index) => {
        if (filterConfig.length > 1) {
            setFilterConfig([
                ...filterConfig.slice(0, index),
                ...filterConfig.slice(index + 1)
            ])
        }
        else {
            NotificationManager.error("Không thể xóa.");
        }
    }

    const HandleInputOnChangeConfigType = (value) => {
        const configTypeReport = 4;
        const planConfigCopy = planConfig.map(planConfigItem => {
            if (planConfigItem.colunmName === value) {
                const valueTypeReport = {
                    ...planConfigItem,
                    configTypeID: configTypeReport
                }
                return valueTypeReport
            } else {
                return planConfigItem
            }
        })

        setPlanConfig(planConfigCopy)

        setReportData(planConfigCopy.filter(planConfigItem => { return planConfigItem.configTypeID === configTypeReport }))
    }

    const HandleInputOnChangePinColunm = (value, colunmName) => {
        const pinColunm = value === "Enable" ? true : false
        const planConfigCopy = planConfig.map(planConfigItem => {
            if (planConfigItem.colunmName === colunmName) {
                const valueTypeReport = {
                    ...planConfigItem,
                    pinColunm: pinColunm
                }
                return valueTypeReport
            } else {
                return planConfigItem
            }
        })

        setPlanConfig(planConfigCopy);

        setReportData(planConfigCopy.filter(planConfigItem => { return planConfigItem.configTypeID === 4 }))
    }

    const HandleOnChangePageConfig = (value) => {
        if (value <= 0 && value !== "") {
            NotificationManager.error("Vui lòng nhập số trang lớn hơn 0")
        } else {
            setPageReport(value)
        }
    }

    const HandleAddDataConfig = () => {
        let LastItem = reportData.filter((item, index) => {
            return index === reportData.length - 1;
        });
        if (LastItem[0].colunmName !== "") {
            setReportData([...reportData, ...getDefaultReportData()])
        }
        else {
            NotificationManager.error("Vui lòng hoàn thành dữ liệu trước khi thêm.");
        }
    }

    const HandleDataConfigDelete = ({ currentValue, index }) => {
        if (reportData.length > 1) {
            setReportData([
                ...reportData.slice(0, index),
                ...reportData.slice(index + 1)
            ])
            const planConfigCopy = planConfig.map(planConfigItem => {
                if (planConfigItem.colunmName === currentValue.colunmName) {
                    const valueTypeGeneral = {
                        ...planConfigItem,
                        configTypeID: 0
                    }
                    return valueTypeGeneral
                } else {
                    return planConfigItem
                }
            })
            setPlanConfig(planConfigCopy)
        } else if (reportData.length <= 1 && index === 0) {
            setReportData([
                ...reportData.slice(0, index),
                ...getDefaultReportData(),
                ...reportData.slice(index + 1)]
            )
            const planConfigCopy = planConfig.map(planConfigItem => {
                if (planConfigItem.colunmName === currentValue.colunmName) {
                    const valueTypeGeneral = {
                        ...planConfigItem,
                        configTypeID: 0
                    }
                    return valueTypeGeneral
                } else {
                    return planConfigItem
                }
            })
            setPlanConfig(planConfigCopy)
        }
        else {
            NotificationManager.error("Không thể xóa.");
        }
    }
    const HandleAddConfigInputData = (Parentindex) => {
        //get ParrentIndex
        //get ouput
        if (planConfig[Parentindex].input) {
            // get last In array
            let LastItem = planConfig[Parentindex].input.filter((item, index) => {
                return index === planConfig[Parentindex].input.length - 1;
            });

            // check columName != ""
            if (LastItem[0].feedPlanInputConfig !== "") {
                planConfig[Parentindex].input.push(getDefaultInput());
                setPlanConfig([
                    ...planConfig.slice(0, Parentindex),
                    {
                        ...planConfig[Parentindex],
                        input: planConfig[Parentindex].input,
                    },
                    ...planConfig.slice(Parentindex + 1)
                ]);
            }
            else {
                NotificationManager.error("Vui lòng hoàn thành dữ liệu trước khi thêm.");
            }
        }
    }
    const HandlePlanConfigDeleteOuput = (Parentindex, index) => {
        if (planConfig[Parentindex].output.length > 1) {
            var ds = planConfig[Parentindex].output;
            if (index === 0) {
                ds = planConfig[Parentindex].output.slice(index + 1);
            } else {
                ds = planConfig[Parentindex].output.slice(0, index);
            }

            setPlanConfig([
                ...planConfig.slice(0, Parentindex),
                {
                    ...planConfig[Parentindex],
                    output: ds,
                },
                ...planConfig.slice(Parentindex + 1)
            ]);
        }
        else {
            NotificationManager.error("Không thể xóa.");
        }
    }

    const HandlePlanConfigUpOutput = (Parentindex, index) => {
        if (planConfig[Parentindex].output.length > 1 && index > 0) {
            var copy = planConfig[Parentindex].output[index];
            var ds = planConfig[Parentindex].output;
            ds[index] = ds[index - 1];
            ds[index - 1] = copy;
            // ds[index] = copy;
            setPlanConfig([
                ...planConfig.slice(0, Parentindex),
                {
                    ...planConfig[Parentindex],
                    output: ds,
                },
                ...planConfig.slice(Parentindex + 1)
            ]);
        }
        else {
            NotificationManager.error("Không thể chuyển vị trí.");
        }
    }

    const HandlePlanConfigDownOutput = (Parentindex, index) => {
        if (planConfig[Parentindex].output.length > 1 && index < planConfig[Parentindex].output.length - 1) {
            var copy = planConfig[Parentindex].output[index];
            var ds = planConfig[Parentindex].output;
            ds[index] = ds[index + 1];
            ds[index + 1] = copy;
            // ds[index] = copy;
            setPlanConfig([
                ...planConfig.slice(0, Parentindex),
                {
                    ...planConfig[Parentindex],
                    output: ds,
                },
                ...planConfig.slice(Parentindex + 1)
            ]);
        }
        else {
            NotificationManager.error("Không thể chuyển vị trí.");
        }
    }

    const HandlePlanConfigUpInput = (Parentindex, index) => {
        if (planConfig[Parentindex].input.length > 1 && index > 0) {
            var copy = planConfig[Parentindex].input[index];
            var ds = planConfig[Parentindex].input;
            ds[index] = ds[index - 1];
            ds[index - 1] = copy;
            // ds[index] = copy;
            setPlanConfig([
                ...planConfig.slice(0, Parentindex),
                {
                    ...planConfig[Parentindex],
                    input: ds,
                },
                ...planConfig.slice(Parentindex + 1)
            ]);
        }
        else {
            NotificationManager.error("Không thể chuyển vị trí.");
        }
    }

    const HandlePlanConfigDownInput = (Parentindex, index) => {
        if (planConfig[Parentindex].input.length > 1 && index < planConfig[Parentindex].input.length - 1) {
            var copy = planConfig[Parentindex].input[index];
            var ds = planConfig[Parentindex].input;
            ds[index] = ds[index + 1];
            ds[index + 1] = copy;
            // ds[index] = copy;
            setPlanConfig([
                ...planConfig.slice(0, Parentindex),
                {
                    ...planConfig[Parentindex],
                    input: ds,
                },
                ...planConfig.slice(Parentindex + 1)
            ]);
        }
        else {
            NotificationManager.error("Không thể chuyển vị trí.");
        }
    }
    const HandlePlanConfigDeleteInput = (Parentindex, index) => {
        if (planConfig[Parentindex].input.length > 1) {
            var ds = planConfig[Parentindex].input
            if (index === 0) {
                ds = planConfig[Parentindex].input.slice(index + 1);
            } else {
                ds = planConfig[Parentindex].input.slice(0, index);
            }

            //var ds = planConfig[Parentindex].input.slice(0, index);
            setPlanConfig([
                ...planConfig.slice(0, Parentindex),
                {
                    ...planConfig[Parentindex],
                    input: ds,
                },
                ...planConfig.slice(Parentindex + 1)
            ]);
        }
        else {
            NotificationManager.error("Không thể xóa.");
        }
    }
    const HandleAddConfigReferenceData = (Parentindex, name) => {
        //get ParrentIndex
        //get ouput
        if (planConfig[Parentindex].output) {
            // get last In array
            let LastItem = planConfig[Parentindex].output.filter((item, index) => {
                return index === planConfig[Parentindex].output.length - 1;
            });

            // check columName != ""
            if (LastItem[0].colunmName !== "") {
                planConfig[Parentindex].output.push(getDefaultOuput());
                setPlanConfig([
                    ...planConfig.slice(0, Parentindex),
                    {
                        ...planConfig[Parentindex],
                        output: planConfig[Parentindex].output,
                    },
                    ...planConfig.slice(Parentindex + 1)
                ]);
            }
            else {
                NotificationManager.error("Vui lòng hoàn thành dữ liệu trước khi thêm.");
            }
        }
    }

    const HandleCopyConfig = (indexItem) => {
        const planCopy = planConfig.filter((item, index) => {
            return index === indexItem
        })
        setPlanConfig([
            ...planConfig.slice(0, indexItem),
            ...planCopy,
            ...planCopy,
            ...planConfig.slice(indexItem + 1)
        ])
        // console.log("plan", indexItem, planCopy, planConfig)
    }
    const HandleOnChangeStepManager = (newvalue) => {
        setStepDataManager(newvalue);
    }
    /*=============================================================================================
    Summary:     Xử lý xem template đó có cần kiểm tra ngày deploy tạo trước 2 ngày hay không ?
    Author:      ThanhNS6
    Date:        27-02-2023 
    =============================================================================================*/
    const handleOnclickCheckDate = () => {
        setIsCheckDate(!isCheckDate);
    }
    const Handle = {
        "HandleStepPlanName": {
            "fn": HandleStepPlanName,
            "value": planName,
        },
        "HandleStepNumberPerform": {
            "fn": HandleStepNumberPerform,
            "value": stepNumberPerform,
            "disabled": id ? true : false
        },
        "HandleStepManager": {
            "value": props.DataEmail ? props.DataEmail : [],
            "valueItems": stepDataManager,
            "fn": HandleOnChangeStepManager
        },
        "HandleCheckDate": {
            "isCheckDate": isCheckDate,
            "fn":
            {
                handleOnclickCheckDate
            }
        },
        "HandlePlanConfig": {
            "fn": {
                "btnAddConfigDataClick": HandleAddConfigData,
                "InputOnchange": HandleInputOnchangeGeneral,
                "btnDeleteConfig": HandlePlanConfigDelete,
                "btnUpConfig": HandlePlanConfigUp,
                "btnDownConfig": HandlePlanConfigDown,
                "handleDragDrop": HandleDragDrop,
                "handleChecked": HandleChecked,
                "OnChangePageConfig": HandleOnChangePageConfig,
                "btnAddConfigDataOuput": HandleAddConfigReferenceData,
                "HandleAddConfigInputData": HandleAddConfigInputData,
                "btnDeleteOuputConfig": HandlePlanConfigDeleteOuput,
                "btnDeleteInput": HandlePlanConfigDeleteInput,
                "btnDownInput": HandlePlanConfigDownInput,
                "btnUpInput": HandlePlanConfigUpInput,
                "btnDownOutput": HandlePlanConfigDownOutput,
                "btnUpOutput": HandlePlanConfigUpOutput,
                "btnCopyConfigClick": HandleCopyConfig
            },
            "value": planConfig,//.concat(getDefaultEditBy()),
            "page": pageReport
        },
        "HandlePlanConfigFilter": {
            "fn": {
                "btnAddFilterConfigClick": HandleAddFilterConfig,
                "InputOnchange": HandleInputOnchangeFilter,
                "btnDeleteConfig": HandleFilterConfigDelete,
            },
            "value": filterConfig,
            "valueName": planConfigFilter//.concat(getFilterConfigDefaultAdd())
        },
        "HandlePlanConfigData": {
            "fn": {
                "InputOnchangeConfigType": HandleInputOnChangeConfigType,
                "InputOnchangePinColunm": HandleInputOnChangePinColunm,
                "btnAddDataConfigClick": HandleAddDataConfig,
                "btnDeleteConfig": HandleDataConfigDelete,
            },
            "value": reportData,
            "FeedsConfigField": feedsConfigField
        }
    }

    if (id && !props.DataNew) {
        return (
            <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
                <CircularProgress />
            </div>
        )
    }

    return (
        <div className="plan-template-new">
            <div className="step-group">
                <div className={classes.root}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                            <Step className="" key={label}>
                                <StepLabel>{label}</StepLabel>S
                            </Step>
                        ))}
                    </Stepper>
                </div>
                <div className="plan-template-new-body">


                    {getStepContent(activeStep, Handle, handleOnclickCheckBox)}
                    <div className="action">
                        <Button
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            className={classes.backButton}
                            variant="contained"
                            startIcon={<MdArrowBack />}
                        >
                            lùi lại
                        </Button>
                        {activeStep === steps.length - 1 ? <Button variant="contained" className="btn-next" onClick={handleComplete} startIcon={<MdCheck />}>
                            Hoàn tất
                        </Button>
                            :
                            <Button variant="contained" className="btn-next" onClick={handleNext} startIcon={<MdArrowForward />}>
                                Tiếp theo
                            </Button>

                        }

                    </div>
                </div>
            </div>
        </div>
    );
}
